<ps-ui-header
  (closeSurvey)="goToDashboard($event)"
  (openServiceAccountModal)="selectBuyer($event)"
  (openMultiBuyerModal)="selectMultiBuyer()"
  [isLaunchSurvey]="true"
></ps-ui-header>
<ps-ui-survey-launch
  [surveyId]="surveyId"
  [auth]="auth"
  [umbrellaCompanyId]="umbrellaCompanyId"
></ps-ui-survey-launch>
